class AutoSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.search__input');
    this.form = this.querySelector('form');
    this.debounceTimer = null;
    
    if (this.input && this.form) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    this.input.addEventListener('input', (e) => this.handleSearch(e));
  }

  handleSearch(e) {
    clearTimeout(this.debounceTimer);
    
    const searchTerm = this.input.value.trim();
    
    // Only submit if there's at least 2 characters
    if (searchTerm.length >= 2) {
      this.debounceTimer = setTimeout(() => {
        this.form.submit();
      }, 500);
    }
  }
}

customElements.define('auto-search', AutoSearch);
